export default {
  dbi_global_view_top_genre_per_market: 'Top Genre per Market',
  dbi_global_view_top_market_per_genre: 'Top Market per Genre',
  dbi_global_view_total_market: 'Total Market',
  dbi_global_view_console_games: 'Console Games',
  dbi_global_view_region: 'Region',
  dbi_global_view_markets: 'Markets',
  dbi_global_view_core_markets: 'Core Markets',
  dbi_global_view_year: 'Year',
  dbi_global_view_genre: 'Genre',
  dbi_global_view_main_sub_genre: 'Main + Sub Genre',
  dbi_global_view_downloads: 'Downloads',
  dbi_global_view_top_5_genres_by_revenue: 'Top 5 genres by revenue',
  dbi_global_view_top_5_genres_by_downloads: 'Top 5 genres by downloads',
  dbi_global_view_top_5_regions_by_revenue: 'Top 5 regions by revenue',
  dbi_global_view_top_5_regions_by_downloads: 'Top 5 regions by downloads',
  dbi_global_view_top_5_markets_by_revenue: 'Top 5 markets by revenue',
  dbi_global_view_top_5_markets_by_downloads: 'Top 5 markets by downloads',
  dbi_global_view_genre_classification_data_source_tips: 'Genre classification and data come from {source} , and was not updated since 2024',
  dbi_global_view_genre_classification_data_source_tips_mobile:
    'Genre classification comes from IEGG and data comes from data.ai',
  dbi_global_view_search_any_region: 'Search any region in the table',
  dbi_global_view_search_any_market: 'Search any market in the table',
  dbi_global_view_search_any_genre: 'Search any genre in the table',
  dbi_global_view_market_settings: 'Market Settings',
  dbi_global_view_1st_genre_revenue: '1st Genre & Revenue',
  dbi_global_view_2nd_genre_revenue: '2nd Genre & Revenue',
  dbi_global_view_3rd_genre_revenue: '3rd Genre & Revenue',
  dbi_global_view_1st_genre_downloads: '1st Genre & Downloads',
  dbi_global_view_2nd_genre_downloads: '2nd Genre & Downloads',
  dbi_global_view_3rd_genre_downloads: '3rd Genre & Downloads',
  dbi_global_view_1st_region_revenue: '1st Region & Revenue',
  dbi_global_view_2nd_region_revenue: '2nd Region & Revenue',
  dbi_global_view_3rd_region_revenue: '3rd Region & Revenue',
  dbi_global_view_1st_region_downloads: '1st Region & Downloads',
  dbi_global_view_2nd_region_downloads: '2nd Region & Downloads',
  dbi_global_view_3rd_region_downloads: '3rd Region & Downloads',
  dbi_global_view_1st_markets_revenue: '1st Markets & Revenue',
  dbi_global_view_2nd_markets_revenue: '2nd Markets & Revenue',
  dbi_global_view_3rd_markets_revenue: '3rd Markets & Revenue',
  dbi_global_view_1st_markets_downloads: '1st Markets & Downloads',
  dbi_global_view_2nd_markets_downloads: '2nd Markets & Downloads',
  dbi_global_view_3rd_markets_downloads: '3rd Markets & Downloads',
  dbi_global_view_by_revenue: 'By Revenue',
  dbi_global_view_by_Players: 'By Players',
  dbi_global_view_market_header: 'Market Size',
  dbi_global_view_golbal_market: 'Global Game Market Summary',
  dbi_global_view_year_revenue: 'Revenue($)',
  dbi_global_view_trends_market_platform: 'Trends of Market Size by Platform',
  dbi_global_view_trends_revenue_region: 'Trends of Market Size by Key Region',
  dbi_global_view_region_genre: 'Region Perfomance by Genre',
  dbi_global_view_year_map: 'Revenue & Growth Map',
  dbi_global_view_year_details: 'Revenue & Growth Details',
  dbi_global_view_game_count: 'Game Count',
  dbi_global_view_revenue_growth: 'Revenue Growth',
  dbi_global_view_revenue_global: 'Revenue Per Global',
  dbi_global_view_play_online_population: 'Online Population',
  dbi_global_view_play_trends: 'Trends of Total Players',
  dbi_global_view_play_trends_payers: 'Trends of Total Payers',
  dbi_global_view_play_region: 'Game Payers By Key Region',
  dbi_global_view_play_Abbreviation_year: 'Abbreviation of year on year, the data is compared with those last year.',
  dbi_global_view_play_map: 'Players & Payers Map',
  dbi_global_view_play_details: 'Players & Annual Spend/Payer Market Details',
  dbi_global_view_play_payers: 'Lots of Players & Lots of Payers',
  dbi_global_view_play_annual: 'Annual Spend/Payer($)',
  dbi_global_view_play_little_payers: 'Lots of Players, Few payers',
  dbi_global_view_growth: 'Growth',
  dbi_global_view_players: 'Players',
  dbi_global_view_payers: 'Payers',
  dbi_global_view_payers2: 'Payers',
  dbi_global_view_revenue_tip_text: 'Here provides revenue data for approximately the top 100 markets. We chose to categorize them based on the median income and annual growth rate. Markets with an income greater than or equal to the median, and an annual growth rate greater than or equal to the median, are characterized as "Star Markets". Markets with an income greater than or equal to the median, but an annual growth rate less than the median, are deemed "Cash Cow Markets". Markets with an income less than the median, yet an annual growth rate greater than or equal to the median, fall under "Question Mark Markets". Finally, those with both income and annual growth rate less than the median are labelled as "Dog Markets".',
  dbi_global_view_player_tip_text: 'Here provides data on players and paying players for approximately 100 leading countries or markets. We use the median number of players and paying players as a standard for segmentation. Markets with a number of players equal to or greater than the median across 100 markets, and paying players equal to or greater than the median, are classified as "Lots of players, lots of payers" markets. Markets with numbers of players equal to or greater than the median across 100 markets, but paying player counts less than the median, are classified as "Lots of players, few payers" markets. We also display the average annual gaming spend of paying players.',
};
